module.exports = __webpack_public_path__ + "img/12.b887fcc1.png";